<template>
  <a-modal
    :title="modalTit"
    :visible="isLimitDialogShow"
    :ok-text="okTTxt"
    :cancel-text="cancelTxt"
    width="500px"
    :mask-closable="false"
    :confirm-loading="confirmLoading"
    @ok="formHandle"
    @cancel="isLimitDialogShow=false"
  >
    <div class="deal-reason-dilog-form">
      <a-form
        ref="createForm"
        :form="form"
        :hide-required-mark="true"
        class="demo-form-inline"
      >
        <a-form-item
          :label="`${remarkTxt}：`"
          prop="reason"
          :label-col="{ span: 5 }"
          :wrapper-col="{ span: 16 }"
        >
          <a-input
            v-decorator="[
              'reason']"
            type="text"
            :placeholder="remarkConPlace"
          />
        </a-form-item>
      </a-form>
    </div>
  </a-modal>
</template>
<script>
export default {
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      submiting: false,
      isLimitDialogShow: false,
      confirmLoading: false
    }
  },
  computed: {
    remarkTxt () {
      return this.$t('message["27"]')
    },
    modalTit () {
      return this.$t('message["65"]')
    },
    remarkConPlace () {
      return this.$t('message["757"]')
    },
    cancelTxt () {
      return this.$t('message["896"]')
    },
    okTTxt () {
      return this.$t('message["915"]')
    }
  },
  mounted () {
  },
  created () {
    this.form = this.$form.createForm(this)
  },
  methods: {
    changeVisible (isShow) {
      this.isLimitDialogShow = isShow
    },
    formHandle () {
      this.form.validateFieldsAndScroll(async (err, values) => {
        if (!err) {
          const formDatas = Object.assign(values, { id: this.id })
          this.$emit('getData', formDatas)
          this.form.resetFields()
          this.isLimitDialogShow = false
        }
      })
    }
  }
}
</script>
<style scoped>
  .deal-reason-dilog-form {
    margin-top: 20px;
  }
</style>
